import toastMessage from "../../utils/toastMessage";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchWalletBalance = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/fundTransfer/balances`,
      data: null, //force axios send headers content type
      params,
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchSingleWallet = async (lng = "english", params) => {
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("report")}/merchant/fundTransfer/balance/${
        params.publicId
      }/history`,
      data: null, //force axios send headers content type
      params,
      headers,
    };

    const data = await axios(options);

    return data.data;
  } catch (error) {
    toastMessage("error", error);
  }
};
